import React, { Component } from "react";
import { useTranslation } from "react-i18next";
import Fade from "react-reveal";

class About extends Component {
  
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const profilepic = "images/" + this.props.data.image;
    const bio = this.props.data.bio;
    const phone = this.props.data.phone;
    const email = this.props.data.email;
    const resumeDownload = this.props.data.resumedownload;
    const linkedin = this.props.data.linkedin;
    const github = this.props.data.github;
    const mailto = 'mailto:'+ this.props.data.email;
    const description = this.props.data.description;
    
    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Nordic Giant Profile Pic"
              />
            </div>
            <div className="nine columns main-col">
              <h2>About Me</h2>

              {/* <p>I’m <b>Saori Kurimoto</b>, {description}</p> */}
              {/* <p>{this.props.data}</p> */}
              <p>{MyComponent}</p>
              {/* <p>I'd love to hear from you!</p> */}
              
              <div className="row">
                <div className="columns download">
                  <p>
                    <a href={mailto} className="button" target="_blank">
                      <i className="fa fa-envelope"></i>Email
                    </a>
                    <a href={resumeDownload} className="button">
                      <i className="fa fa-file"></i>Resume
                    </a>
                    <a href={linkedin} className="button" target="_blank">
                      <i className="fa fa-linkedin"></i>LinkedIn
                    </a>

                    <a href={github} className="button" target="_blank">
                      <i className="fa fa-github"></i>GitHub 
                    </a>
                  </p>
                  <p>
                  </p>
                </div>
              </div>
              
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

function MyComponent() {
  const { t, i18n } = useTranslation();
  // or const [t, i18n] = useTranslation();
  console.log('1');

  return <p>{t('manish')}</p> 
}

export default About;
